import { supabase } from './api'

export async function getAllData() {
	const { data, error } = await supabase.from('listcollege').select().order('college_name', { ascending: true })
	if (error) {
		throw new Error(`Failed to fetch college list 2 data: ${error.message}`)
	}
	return data || []
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('listcollege').select().eq('id', id)
	if (error) {
		throw new Error(`Failed to fetch college list 2 row: ${error.message}`)
	}
	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('listcollege').insert(adata).select()
	if (error) {
		throw new Error(`Failed to add college list 2 row: ${error.message}`)
	}
	return data
}

export async function updateData(udata) {
	const { id, ...rest } = udata
	const { data, error } = await supabase.from('listcollege').update(rest).eq('id', id).select()
	if (error) {
		throw new Error(`Failed to update college list 2 row: ${error.message}`)
	}
	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('listcollege').delete().eq('id', id)
	if (error) {
		throw new Error(`Failed to delete college list 2 row: ${error.message}`)
	}
	return data
}
